import { useCallback } from 'react';
import { useMutation } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import { useErrorHandler } from 'lib';
import { useRemoveFlightMutation } from '__generated__/useRemoveFlightMutation.graphql';

type UseRemoveFlight = [remove: () => void, removing: boolean];

export function useRemoveFlight(packageDateId: string): UseRemoveFlight {
  const errorHandler = useErrorHandler();

  const [removeFlight, removing] = useMutation<useRemoveFlightMutation>(graphql`
    mutation useRemoveFlightMutation($id: ID!) {
      removeFlightFromPackageDate(id: $id) {
        ...PackageDateEditTabs_packageDate
        ...PackageDateSidebar_packageDate
      }
    }
  `);

  const handleRemove = useCallback(() => {
    removeFlight({
      variables: { id: packageDateId },
      ...errorHandler(),

      optimisticUpdater: store => {
        store.get(packageDateId)?.setValue(null, 'flight');
      },
    });
  }, [errorHandler, packageDateId, removeFlight]);

  return [handleRemove, removing];
}
